import React from "react";

function D3Icon() {
    return (
        <svg width="34" height="34" xmlns="http://www.w3.org/2000/svg" className="d3js-icon">
            <g>
                <rect fill="none" id="canvas_background" height="18" width="18" y="0" x="0"/>
            </g>
            <g>
                <path fill="#ffffff" stroke="#ffffff" id="svg_1" d="m17.749,16c0,-8.375 -6.791,-15.167 -15.165,-15.167l-2.584,0l0,6.667l2.584,0c4.697,0 8.499,3.807 8.499,8.5s-3.801,8.5 -8.499,8.5l-2.584,0l0,6.667l2.584,0c8.375,0 15.165,-6.792 15.165,-15.167zm14.251,-5.917c0,-5.109 -4.14,-9.249 -9.251,-9.249l-10.667,0c2.625,1.645 4.777,3.943 6.245,6.667l4.421,0c1.428,0 2.584,1.156 2.584,2.583c0,1.428 -1.156,2.584 -2.584,2.584l-2.583,0c0.417,2.203 0.417,4.464 0,6.667l2.583,0c1.423,0 2.584,1.156 2.584,2.584c0,1.432 -1.156,2.588 -2.584,2.588l-4.421,0c-1.468,2.724 -3.62,5.021 -6.245,6.667l10.667,0c2.163,0 4.256,-0.76 5.917,-2.141c3.921,-3.271 4.464,-9.099 1.193,-13.025c1.385,-1.667 2.14,-3.76 2.14,-5.923l0.001,-0.002z"/>
            </g>
        </svg>
    )
}

export default D3Icon